import { orderConstants } from '@utils/constants';
import i18nTranslateValueFromOptions from '@/utils/i18nTranslateValueFromOptions';

export default function statusOrderHTML(value) {
    const translatedValue = i18nTranslateValueFromOptions(value, '_common:statuses');

    switch (value.toUpperCase()) {
        case orderConstants.STATUS.ORDERED:
            return `<span class="status--ordered">${translatedValue}</span>`;
        case orderConstants.STATUS.PAID:
            return `<span class="status--paid">${translatedValue}</span>`;
        case orderConstants.STATUS.PROCESSED:
            return `<span class="status--processed">${translatedValue}</span>`;
        case orderConstants.STATUS.REFUNDED:
            return `<span class="status--refunded">${translatedValue}</span>`;
        case orderConstants.STATUS.CANCELLED:
            return `<span class="status--cancelled">${translatedValue}</span>`;
        case orderConstants.STATUS.DELIVERED:
            return `<span class="status--delivered">$${translatedValue}</span>`;
        case orderConstants.STATUS.REPLACED:
            return `<span class="status--replaced">$${translatedValue}</span>`;
        default:
            return value;
    }
}
